import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  // A shared link opens signed out too: the card's public page and a gift's claim page (docs/architecture/read-api.md
  // § Card features). The edge serves both paths with the card's link-preview tags.
  public: [
    { path: "c/:cardId", lazy: page(() => import("./PublicCardPage")), handle: shows("shares") },
    { path: "gift/:code", lazy: page(() => import("./GiftPage")), handle: shows("gifts") },
  ],
  shell: [{ path: "gifts", lazy: page(() => import("./GiftsPage")), handle: shows("gifts", "cards") }],
};
